import './sobremien.css'

function SobreMiEn() {
    return (
        <div className='sobremi_container' id='sobremi'>
            <div className="sobremi_texto">
                <h3>ABOUT ME</h3>
                <p>I’m <span className="highlight">Lautaro Mazza</span>, a tango singer with over 20 years of experience and a deep passion for tango interpretation. My training began at the Casa del Tango in La Plata and was solidified through over a decade of intensive work with Maestro Mario Bracco. I currently continue my artistic development with the renowned teacher Emilce Vasaro, delving into a line of work that focuses on vocal technique in service of interpreting the genre.
                </p>
                
                <p>
                Since 2014, I have been a member of the Orquesta del Tango de la Ciudad de Buenos Aires, directed by Maestros Juan Carlos Cuacci and Néstor Marconi. I participated in their most recent official album and numerous concerts at some of the city's most prestigious venues.
                </p>
                
                <p>I am a regular guest with the Orquesta Nacional de Música Argentina “Juan de Dios Filiberto” and the Tango Orchestra of the National University of the Arts (UNA), conducted by Maestro Ariel Pirotti.</p>
                
                <p>I had the honor of being the last singer to work with Maestro Raúl Garello, one of tango’s most iconic figures. Throughout my career, I have been specially selected for projects alongside major artists such as Néstor Marconi, Juan Carlos Cuacci, and Rodolfo Mederos, among others.</p>
                
                <p>I have performed on renowned stages such as Teatro Colón, Usina del Arte, Centro Cultural Kirchner, Teatro San Martín, Luna Park, and international venues in Mexico, Colombia, Ecuador, and Brazil.</p>
            </div>
            <div className="sobremi_foto">
            </div>
        </div>
    )
}

export default SobreMiEn